<script>
    import InfoPageTemplate from './InfoPageTemplate.svelte';
    import { _ } from 'svelte-i18n';
    import PositionsTable from './PositionsTable.svelte';
    import { onMount } from 'svelte';

    onMount(() => {
        window.scrollTo(0, 0);
    });
</script>

<style>
    .footnote {
        line-height: 1.5;
    }

    .positionsTable {
        width: 100%;
        overflow-x: scroll;
    }
</style>

<InfoPageTemplate>
    <div slot="header-section">
        <h1>{$_('learn.infopage_2.title')}</h1>
    </div>
    <div slot="content-section">
        <h2>{$_('learn.infopage_2.content_table1')}</h2>
        <div class="positionsTable">
            <PositionsTable muscleGroupType="leg" />
        </div>
        <h2>{$_('learn.infopage_2.content_table2')}</h2>
        <div class="positionsTable">
            <PositionsTable muscleGroupType="arm" />
        </div>
    </div>
    <div class="footnote" slot="footer-section">
        {$_('learn.infopage_2.footer')}
    </div>
</InfoPageTemplate>